import React from "react";
import style from "./Loading.module.css";
import Animation from "../../../assets/images/loading5.gif";

const BodyLoading = () => {
  return (
    <div
      className={`w-100 h-100 d-flex ${style.loader} justify-content-center align-items-center`}
    >
      <p className="text-light fs-3">Loading...</p>
      {/* <img src={Animation} alt="loading img"></img> */}
    </div>
    // <div
    //   class={`w-100 h-100 d-flex justify-content-center align-items-center`}
    //   // style={{ background: rgb(0, 0, 0) }}
    // >
    //   <div className={`${style.loader}`}></div>
    // </div>
  );
};

export default BodyLoading;
